import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { getApiVersion } from "../api/app/getApiVersion";
import {
  API_VERSION,
  getLocalStorageItem,
  setLocalStorageItem,
} from "../helpers/localStorage";
import { SHORT_STALE_TIME } from "../providers/APQueryProvider";

const ApiVersionCheck = () => {
  const navigate = useNavigate();
  const currentVersion = getApiVersion({ refetchInterval: SHORT_STALE_TIME });

  useEffect(() => {
    if (currentVersion.data) {
      const storedVersion = getLocalStorageItem<string>(API_VERSION);

      if (!storedVersion && currentVersion.data) {
        setLocalStorageItem(API_VERSION, currentVersion.data);
      } else if (storedVersion !== currentVersion.data) {
        setLocalStorageItem(API_VERSION, currentVersion.data);
        navigate(0);
      }
    }
  }, [currentVersion.dataUpdatedAt, currentVersion.data]);

  // Handle focus events to check for version updates when user returns to the app
  useEffect(() => {
    const handleFocus = () => {
      // Refetch the API version when the user returns to the app
      currentVersion.refetch();
    };

    // Add event listeners for when the user returns to the app
    window.addEventListener("focus", handleFocus);
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        handleFocus();
      }
    });

    return () => {
      window.removeEventListener("focus", handleFocus);
      document.removeEventListener("visibilitychange", handleFocus);
    };
  }, [currentVersion.refetch]);

  return <></>;
};

export default ApiVersionCheck;
